import { DOCUMENT } from '@angular/common';
import { EventEmitter, Inject, Injectable } from '@angular/core';
import { SEOService } from './seo.service';
import { StorageService } from './storage.service';
import { TranslateService } from '../../shared/modules/translate/translate.service';
import { AuthGuardService } from './auth/auth-guard.service';
import { PlatformService } from './platform.service';

@Injectable({ providedIn: 'root' })
export class I18nService {
  private _language: string | null = null;
  private _isRTL = false;
  languageInUrl = false;
  urlLanguage: string | null = null;

  dir: string = 'ltr' as any;
  get isRTL() {
    return this._isRTL;
  }

  get language(): string {
    if (!this._language) this.setLanguage();
    return this._language as string;
  }

  // languageChanged = new EventEmitter();
  constructor(
    private storage: StorageService,
    private translationService: TranslateService,
    @Inject(DOCUMENT) private document: Document,
    private seoService: SEOService,
    private authGuardService: AuthGuardService,
    private pt: PlatformService
  ) { }

  setLanguage(targetLang: string | undefined = undefined, prefentIfNotServer = false) {
    if (prefentIfNotServer && !this.pt.isServer) {
      return
    }
    if (targetLang) {
      this._language = targetLang;
    } else {
      const langFromUrl = this.document.location.pathname
        .split('/')
        .filter((c) => c)[0];
      switch (langFromUrl) {
        case 'en':
        case 'ar':
        case 'zh':
        case 'es':
        case 'hi':
        case 'bn':
        case 'pt':
        case 'ru':
        case 'fr':
        case 'ur':
          {
            // console.log('language from url', langFromUrl);

            this.urlLanguage = langFromUrl;
            this.languageInUrl = true;
            this._language = langFromUrl;
          }
          break;
        default:
          {

            if (this.authGuardService.currentUser?.languageCode) {
              this._language = this.authGuardService.currentUser?.languageCode as string;
            } else {

              this._language = this.storage.i18n.value as string;
            }
          }
          break;
      }
    }

    this.dir = this._language == 'ar' || this._language == 'ur' ? 'rtl' : 'ltr';
    this._isRTL = this.dir == 'rtl';
    this.translationService.setLanguage(this._language as string);
    this.seoService.setLanguage(this._language);
    this.storage.i18n.value = this._language as string;
    this.document.documentElement.dir = this.dir;
    this.document.documentElement.lang = this._language as any;


    if (this.isRTL) {
      this.document.head.insertAdjacentHTML("afterbegin", `
  <!-- Preload Cairo font -->
  <link rel="preload" as="style"
    href="https://fonts.googleapis.com/css2?family=Cairo:slnt,wght@-11..11,200..1000&display=swap">
  <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Cairo:slnt,wght@-11..11,200..1000&display=swap"
    media="all" onload="this.onload=null;this.rel='stylesheet';">
  `)
    } else {
      this.document.head.insertAdjacentHTML("afterbegin", `
        <!-- Preload Poppins font -->
      <link rel="preload" as="style"
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap">
      <link rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap"
        media="all" onload="this.onload=null;this.rel='stylesheet';">
    
           `)
    }

    // if (!environment.production) {
    //   this.changeStyle();
    // }

    //this.languageChanged.emit();
  }

  resetLanguage(lang: string) {
    if (!lang || lang == this._language) return;
    // if (!this.languageInUrl) {
    //   this.router.navigateByUrl(
    //     window.location.href.replace(`/${this.urlLanguage}`, `/${lang}`)
    //   );
    // }

    (this.document.defaultView as any).urlLanguage = lang;
    (this.document.defaultView as any).lang = lang;
    this._language = null;
    this.setLanguage(lang);
    // (this.document.defaultView as any).changeLanguage(this._language);
  }

  private changeStyle() {
    this.document.head.querySelector('#mainStyle')?.remove();
    this.document.head.insertAdjacentHTML(
      'beforeend',
      `<link rel="stylesheet" id="mainStyle"  href="assets/css/style.${this.dir}.css" />`,
    );
  }
}
